import { TextField, TextFieldProps } from '@mui/material';
import { useIsDesktop } from 'Hooks';
import { requiredMessage } from 'Regex';
import { UseFormRegisterReturn } from 'react-hook-form/dist/types';

export const TextInput = (
  props: TextFieldProps & {
    label: string;
    register: UseFormRegisterReturn<string>;
    errors?: { message: string };
    shrink: boolean;
    isNumbersOnly?: boolean;
  }
) => {
  const isDesktop = useIsDesktop();

  return (
    <TextField
      label={props.label}
      error={props.errors?.message !== undefined}
      helperText={props.errors?.message}
      variant='outlined'
      inputProps={{
        inputMode: props.isNumbersOnly ? 'numeric' : undefined,
        min: 0,
        style: {
          padding: '0 14px',
          height: isDesktop ? '48px' : '42px',
        },
        'aria-required': props.errors?.message === requiredMessage,
      }}
      InputLabelProps={{
        shrink: props.shrink,
      }}
      sx={{
        width: isDesktop ? '400px' : '100%',
        borderRadius: '6px',
        '& .MuiOutlinedInput-notchedOutline': {
          borderRadius: '6px',
          border: '1px solid',
          borderColor: 'primary.shade_200',
        },
        '&&& .Mui-focused .MuiOutlinedInput-notchedOutline': {
          borderRadius: '6px',
          border: '1px solid',
          borderColor: 'primary.main',
        },
        '.MuiOutlinedInput-root': {
          '&:hover fieldset': {
            borderColor: 'primary.main',
          },
        },
        '& .MuiInputLabel-root[data-shrink="false"]': {
          mt: isDesktop ? '-5px' : '-8px',
        },
        ...props.sx,
      }}
      {...props.register}
    />
  );
};
